<template>
  <div>
    <div class="mb-1 tw-text-xl tw-font-bold tw-mb-3">
      {{ headerTitle }}
    </div>
  <v-card id="table-firebase" min-height="740">

    <v-container fluid class="tw-p-4">
      <div>
        <h1 class="tw-font-bold tw-pb-7">
          เงื่อนไข การค้นหาและการส่งออกข้อมูล
        </h1>
      </div>

      <div class="input-group tw-grid tw-grid-cols-2 tw-gap-14 tw-max-w-4xl">
        <!-- Left Column -->
        <div class="left-col tw-gap-3 tw-grid tw-grid-cols-1 tw-items-left">
          <div class="tw-grid tw-grid-cols-2 tw-items-left">
            <div>สาขากิจการ</div>
            <v-select  :menu-props="{ bottom: true, offsetY: true }" v-model="filterData.branchID" label="เลือกสาขากิจการ" :items="branchList" item-value="code"
              item-text="description" outlined dense hide-details></v-select>
          </div>
          <div class="tw-grid tw-grid-cols-2 tw-row-span-3 tw-items-center tw-h-full">
            <div>รหัสภาษีมูลค่าเพิ่ม</div>
            <div class="tw-flex tw-flex-col tw-justify-evenly tw-h-full hide-scroll-bar tw-px-1"
                 style="border-radius: 10px !important;border: 1px solid rgba(0, 0, 0, 0.5); border-radius: 4px; font-size: 14px; padding: 8px">
              <v-checkbox v-for="(taxCode, index) in vatCodes" :key="index"
                          v-model="filterData.taxCodeTypes[taxCode.code]" value=""
                          :label="`${taxCode.code}: ${taxCode.description}`" hide-details dense
                          class="tw-mt-0 tw-pt-0 tw-whitespace-nowrap tw-tracking-tighter"></v-checkbox>
            </div>
          </div>
          <div class="tw-grid tw-grid-cols-2 tw-items-center">
            <div>สถานะ Submit</div>
            <div>
              <v-select  :menu-props="{ bottom: true, offsetY: true }" v-model="filterData.submitStatus" label="เลือกสถานะ Submit" :items="statusSubmit"
                item-value="code" item-text="description" outlined dense hide-details></v-select>
            </div>
          </div>
          <!-- <div class="tw-grid tw-grid-cols-2 tw-items-center">
            <div>ชื่อผู้ซื้อสินค้า/ผู้รับบริการ</div>
            <v-text-field v-model="filterData.payeeName" label="กรอกชื่อผู้ซื้อ" outlined dense hide-details
              class="tw-mb-0"></v-text-field>
          </div> -->
        </div>

        <!-- Right Column -->
        <div class="right-col tw-items-left tw-space-y-4">
          <!-- <div class="tw-grid tw-grid-cols-2 tw-items-center">
            <div>สถานะเอกสาร</div>
            <v-select  :menu-props="{ bottom: true, offsetY: true }" v-model="filterData.transactionStatus" label="เลือกสถานะเอกสาร" :items="transactionStatusList"
              item-value="code" item-text="description" outlined dense hide-details></v-select>
          </div>
          <div class="tw-grid tw-grid-cols-2 tw-items-center">
            <div>รูปแบบใบกำกับภาษี</div>
            <v-select  :menu-props="{ bottom: true, offsetY: true }" v-model="filterData.ivType" label="เลือกรูปแบบใบกำกับภาษี" :items="formatInvoice" item-value="code"
              item-text="description" outlined dense hide-details></v-select>
          </div> -->
          <div class="tw-grid tw-grid-cols-2 tw-items-left">
            <div>จากวันที่เอกสาร</div>
            <v-menu v-model="fromDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field prepend-inner-icon="mdi-calendar-month-outline" readonly :value="fromDateDisp" v-on="on"
                label="จากวันที่เอกสาร"
                  outlined dense hide-details clearable @click:clear="fromDateVal = null"></v-text-field>
              </template>
              <v-date-picker color="primary" locale="en-in" v-model="fromDateVal" no-title @input="fromDateMenu = false"
                :min="minDate"></v-date-picker>
            </v-menu>
          </div>

          <div class="tw-grid tw-grid-cols-2 tw-items-left">
            <div>ถึงวันที่เอกสาร</div>
            <v-menu v-model="toDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field prepend-inner-icon="mdi-calendar-month-outline" readonly :value="toDateDisp" v-on="on"
                label="ถึงวันที่เอกสาร"
                  outlined dense hide-details clearable @click:clear="toDateVal = null"></v-text-field>
              </template>
              <v-date-picker color="primary" locale="en-in" v-model="toDateVal" no-title @input="toDateMenu = false"
                :min="minDateTax"></v-date-picker>
            </v-menu>
          </div>
           <div class="tw-grid tw-grid-cols-2 tw-items-left">
            <div>ชื่อผู้ซื้อสินค้า/ผู้รับบริการ</div>
            <v-text-field v-model="filterData.payeeName" label="กรอกชื่อผู้ซื้อ" outlined dense hide-details
              class="tw-mb-0"></v-text-field>
          </div>
          <div class="tw-grid tw-grid-cols-1 tw-row-span-2 tw-gap-3 tw-items-center place-items-center tw-py-6">
            <div class="tw-flex tw-justify-end tw-gap-2">
              <v-btn color="warning" class="white--text" @click="resetSearchData()" style="font-size: 14px" outlined>
                ล้าง
              </v-btn>
              <v-btn color="primary" class="white--text" @click="handleSearchClick()" style="font-size: 14px">
                <v-icon left>mdi-magnify</v-icon>
                การค้นหา
              </v-btn>
              <v-btn color="primary" class="white--text" style="font-size: 14px" @click="exportExcel(); selectedAll = false;">
              <!-- @click="onClickAttach(selectedTaxWHCode)" -->
              Export Excel
              </v-btn>
            </div>
          </div>
        </div>
      </div>


    </v-container>

    <v-divider class="tw-pb-4" />
    <v-container v-if="alert.show">
      <v-row>
        <v-col cols="12">
          <v-alert v-model="alert.show" :type="alert.type" transition="scale-transition" dismissible>{{ alert.text
          }}</v-alert>
        </v-col>
      </v-row>
    </v-container>
    <!-- docs::
    {{
    docs.length
     }} -->
    <v-dialog v-model="pdfDialog">
      <div>
        <iframe class="iframe" :src="pdfSrc"></iframe>
      </div>
    </v-dialog>

    <v-simple-table

    >
      <template v-slot:default>
        <thead>
        <tr id="header-table">
          <th>
            <v-checkbox v-model="selectedAll" color="#6ec39b" class="btn-choose" @change="clickSelectedAll($event)">
              <v-checkbox v-model="selectedAll" color="#6ec39b" class="btn-choose"
                          @change="clickSelectedAll($event)">
              </v-checkbox>
            </v-checkbox>

          </th>

          <th class="text-left order-by-row" @click="changeOrderBy('taxCondition')" v-if="showColumn('taxCondition')">
            ประเภทเอกสาร
            <img v-if="orderBySelect['key'] === 'taxCondition'" src="/images/icons/icon-filter.svg" alt="filter"
                 v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                 style="margin-left: 4px; display: inline-flex"/>
            <v-icon dark color="#707070" v-if="orderBySelect['key'] !== 'taxCondition'"
                    class="icon-sort">mdi-menu-swap
            </v-icon>
          </th>

          <th class="text-left order-by-row" @click="changeOrderBy('transactionid')">
            เดือนที่ยื่นภาษี
            <img v-if="orderBySelect['key'] === 'transactionid'" src="/images/icons/icon-filter.svg" alt="filter"
                 v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                 style="margin-left: 4px; display: inline-flex"/>
            <v-icon dark color="#707070" v-if="orderBySelect['key'] !== 'transactionid'"
                    class="icon-sort">mdi-menu-swap
            </v-icon>
          </th>
          <th class="text-left order-by-row" @click="changeOrderBy('taxInvoiceID')">
            เลขที่ใบกำกับภาษี
            <img v-if="orderBySelect['key'] === 'taxInvoiceID'" src="/images/icons/icon-filter.svg" alt="filter"
                 v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                 style="margin-left: 4px; display: inline-flex"/>
            <v-icon dark color="#707070" v-if="orderBySelect['key'] !== 'taxInvoiceID'"
                    class="icon-sort">mdi-menu-swap
            </v-icon>
          </th>
          <th class="text-left order-by-row" @click="changeOrderBy('docTaxDate')" v-if="showColumn('docTaxDate')">
            วันที่ใบกำกับภาษี
            <img v-if="orderBySelect['key'] === 'docTaxDate'" src="/images/icons/icon-filter.svg" alt="filter"
                 v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                 style="margin-left: 4px; display: inline-flex"/>
            <v-icon dark color="#707070" v-if="orderBySelect['key'] !== 'docTaxDate'"
                    class="icon-sort">mdi-menu-swap
            </v-icon>
          </th>
          <th class="text-left order-by-row" @click="changeOrderBy('customerName')" v-if="showColumn('customerName')">
            ชื่อผู้ซื้อสินค้า/ผู้รับบริการ
            <img v-if="orderBySelect['key'] === 'customerName'" src="/images/icons/icon-filter.svg" alt="filter"
                 v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                 style="margin-left: 4px; display: inline-flex"/>
            <v-icon dark color="#707070" v-if="orderBySelect['key'] !== 'customerName'"
                    class="icon-sort">mdi-menu-swap
            </v-icon>
          </th>
          <th class="text-left order-by-row" @click="changeOrderBy('customerTaxId')" v-if="showColumn('customerTaxId')">
            เลขประจำตัวผู้เสียภาษี
            <img v-if="orderBySelect['key'] === 'customerTaxId'" src="/images/icons/icon-filter.svg" alt="filter"
                 v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                 style="margin-left: 4px; display: inline-flex"/>
            <v-icon dark color="#707070" v-if="orderBySelect['key'] !== 'customerTaxId'"
                    class="icon-sort">mdi-menu-swap
            </v-icon>
          </th>
          <th class="text-left order-by-row" @click="changeOrderBy('customerBranch')"
              v-if="showColumn('customerBranch')">
            สาขาคู่ค้า
            <img v-if="orderBySelect['key'] === 'customerBranch'" src="/images/icons/icon-filter.svg" alt="filter"
                 v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                 style="margin-left: 4px; display: inline-flex"/>
            <v-icon dark color="#707070" v-if="orderBySelect['key'] !== 'customerBranch'"
                    class="icon-sort">mdi-menu-swap
            </v-icon>
          </th>
          <th class="text-left order-by-row" @click="changeOrderBy('taxCode')" v-if="showColumn('taxCode')">
            รหัสภาษีมูลค่าเพิ่ม
            <img v-if="orderBySelect['key'] === 'taxCode'" src="/images/icons/icon-filter.svg" alt="filter"
                 v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                 style="margin-left: 4px; display: inline-flex"/>
            <v-icon dark color="#707070" v-if="orderBySelect['key'] !== 'taxCode'"
                    class="icon-sort">mdi-menu-swap
            </v-icon>
          </th>

          <th class="text-right order-by-row" @click="changeOrderBy('taxSumBaseAmount')"
              v-if="showColumn('taxSumBaseAmount')">{{ taxCoditon =='avg'?'มูลค่าสินค้า/บริการ (TAX 7%)':'มูลค่าสินค้า/บริการ' }}
            
            <img v-if="orderBySelect['key'] === 'taxSumBaseAmount' && !keyword" src="/images/icons/icon-filter.svg"
                 alt="filter" v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                 style="margin-left: 4px; display: inline-flex"/>
            <v-icon dark color="#707070" v-if="orderBySelect['key'] !== 'taxSumBaseAmount' && !keyword"
                    class="icon-sort">mdi-menu-swap
            </v-icon>
          </th>
          <th class="text-right order-by-row" @click="changeOrderBy('taxSumAmount')" v-if="showColumn('taxSumAmount')">
            {{ taxCoditon =='avg'?'ภาษีมูลค่าเพิ่ม (TAX 7%)':'ภาษีมูลค่าเพิ่ม' }} 
            <img v-if="orderBySelect['key'] === 'taxSumAmount' && !keyword" src="/images/icons/icon-filter.svg"
                 alt="filter" v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                 style="margin-left: 4px; display: inline-flex"/>
            <v-icon dark color="#707070" v-if="orderBySelect['key'] !== 'taxSumAmount' && !keyword"
                    class="icon-sort">mdi-menu-swap
            </v-icon>
          </th>
          <th class="text-right order-by-row" @click="changeOrderBy('taxDoctotal')" v-if="showColumn('taxDoctotal')">
            {{ taxCoditon =='avg'?'รวมทั้งหมด (TAX 7%)':'รวมทั้งหมด' }} 
            <img v-if="orderBySelect['key'] === 'taxDoctotal' && !keyword" src="/images/icons/icon-filter.svg"
                 alt="filter" v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                 style="margin-left: 4px; display: inline-flex"/>
            <v-icon dark color="#707070" v-if="orderBySelect['key'] !== 'taxDoctotal' && !keyword"
                    class="icon-sort">mdi-menu-swap
            </v-icon>
          </th> 
          <!-- add fill vat average -->
          <th class="text-right order-by-row" @click="changeOrderBy('taxDoctotal')" v-if=" taxCoditon ==='avg'">
            มูลค่าสินค้า/บริการ (AVG TAX)
            <img v-if="orderBySelect['key'] === 'taxDoctotal' && !keyword" src="/images/icons/icon-filter.svg"
                 alt="filter" v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                 style="margin-left: 4px; display: inline-flex"/>
            <v-icon dark color="#707070" v-if="orderBySelect['key'] !== 'taxDoctotal' && !keyword"
                    class="icon-sort">mdi-menu-swap
            </v-icon>
          </th> 
          <th class="text-right order-by-row" @click="changeOrderBy('taxDoctotal')" v-if=" taxCoditon ==='avg'">
            ภาษีมูลค่าเพิ่ม (AVG TAX)
            <img v-if="orderBySelect['key'] === 'taxDoctotal' && !keyword" src="/images/icons/icon-filter.svg"
                 alt="filter" v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                 style="margin-left: 4px; display: inline-flex"/>
            <v-icon dark color="#707070" v-if="orderBySelect['key'] !== 'taxDoctotal' && !keyword"
                    class="icon-sort">mdi-menu-swap
            </v-icon>
          </th> 
          <th class="text-right order-by-row" @click="changeOrderBy('taxDoctotal')" v-if=" taxCoditon ==='avg'">
            รวมทั้งหมด (AVG TAX)
            <img v-if="orderBySelect['key'] === 'taxDoctotal' && !keyword" src="/images/icons/icon-filter.svg"
                 alt="filter" v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                 style="margin-left: 4px; display: inline-flex"/>
            <v-icon dark color="#707070" v-if="orderBySelect['key'] !== 'taxDoctotal' && !keyword"
                    class="icon-sort">mdi-menu-swap
            </v-icon>
          </th> 
            <!--end add fill vat average -->
          <th class="text-center order-by-row">
            ลิงก์
          </th>
        </tr>
        </thead>
        <tbody>
        <template v-if="!isLoading">
          <tr
              v-for="doc in data" :key="doc.id" class="tr-data">
            <td>
              <div :class="checkDisabledCheckbox(doc) ? 'tw-cursor-not-allowed' : ''">
                <v-checkbox color="#6ec39b" :input-value="getCheckedSelect(doc['documentID'])"
                            class="remove-checkbox-padding shrink mr-0 mt-0" @change="clickSelected(doc)"
                            :disabled="checkDisabledCheckbox(doc)"
                            :class="checkDisabledCheckbox(doc) ? 'checkbox-disabled' : ''"
                            hide-details="auto"></v-checkbox>
              </div>
            </td>

            <td @mousedown="startDrag" @mouseup="stopDrag(doc)" @mousemove="doDrag">
              {{ doc["transactionType"] }}
              <!-- {{ handlePayeeType(doc["taxCondition"]) }} -->
            </td>
            <td @mousedown="startDrag" @mouseup="stopDrag(doc)" @mousemove="doDrag">
              <!-- {{ doc["transactionid"] }} -->
              {{ displayThaiMonthAndYear(doc.submitPeriod, doc) }}
            </td>
            <td @mousedown="startDrag" @mouseup="stopDrag(doc)" @mousemove="doDrag">
              {{ doc["taxInvoiceID"] }}
            </td>

            <td v-if="showColumn('docTaxDate')" @mousedown="startDrag" @mouseup="stopDrag(doc)" @mousemove="doDrag">
              <!-- {{ doc["docTaxDate"] || "-" }} -->
              {{ getDateWithFormat(doc["docTaxDate"]) }}
              <!-- {{ doc["docTaxDate"] }} -->
            </td>

            <!-- <td
              v-if="showColumn('entityBranch')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ getTaxId(doc["entityBranch"], companyID) }}
            </td> -->
            <td v-if="showColumn('customerName')" @mousedown="startDrag" @mouseup="stopDrag(doc)" @mousemove="doDrag">
              <pre>{{ doc["customerName"] }}</pre>
            </td>
            <td v-if="showColumn('customerTaxId')" @mousedown="startDrag" @mouseup="stopDrag(doc)" @mousemove="doDrag">
              {{ doc["customerTaxId"] || "-" }}
            </td>
            <td v-if="showColumn('customerBranch')" @mousedown="startDrag" @mouseup="stopDrag(doc)" @mousemove="doDrag">
              {{ doc["customerBranch"] }}
            </td>

            <td v-if="showColumn('taxCode')" @mousedown="startDrag" @mouseup="stopDrag(doc)" @mousemove="doDrag">
              {{ doc["taxCode"] }}
            </td>
            <!-- มูลค่าบริการ สินค้า -->
            <td class="text-right" v-if="showColumn('taxSumBaseAmount')" @mousedown="startDrag" @mouseup="stopDrag(doc)"
                @mousemove="doDrag">
              {{ formatCurrency(doc["taxSumBaseAmount"]) }}
            </td>

            <td class="text-right" v-if="showColumn('taxSumAmount')" @mousedown="startDrag" @mouseup="stopDrag(doc)"
                @mousemove="doDrag">
              {{ formatCurrency(doc["taxSumAmount"]) }}
            </td>

            <td class="text-right" v-if="showColumn('taxDoctotal')" @mousedown="startDrag" @mouseup="stopDrag(doc)"
                @mousemove="doDrag">
              {{ formatCurrency(doc["taxDoctotal"]) }}
            </td>
            <!-- data for tax Average -->
            <td class="text-right" v-if="taxCoditon =='avg'" @mousedown="startDrag" @mouseup="stopDrag(doc)"
                @mousemove="doDrag">
              {{ formatCurrency(doc["taxSumBaseAmountAvg"]) }}
            </td>
            <td class="text-right" v-if="taxCoditon =='avg'" @mousedown="startDrag" @mouseup="stopDrag(doc)"
                @mousemove="doDrag">
              {{ formatCurrency(doc["taxSumAmountAvg"]) }}
            </td>
            <td class="text-right" v-if="taxCoditon =='avg'" @mousedown="startDrag" @mouseup="stopDrag(doc)"
                @mousemove="doDrag">
              {{ formatCurrency(doc["taxDocTotalAvg"]) }}
            </td>
            <!--end data for tax Average --> 
            <td class="text-left" v-if="showColumn('link')">
              <v-btn color="primary" depressed icon outlined target="_blank"
                     :href="doc.link ? doc.link : 'about:blank'">
                <v-icon small> mdi mdi-file-document-edit-outline</v-icon>
              </v-btn>
            </td> 
          </tr>
        </template>
        </tbody>
      </template>
    </v-simple-table
>


    <div v-if="docs.length == 0 && !loading" class="tw-text-center tw-w-full tw-opacity-80 tw-py-40">
      <h2>ไม่พบเอกสารที่ต้องการ</h2>
    </div>
    <!-- <div v-if="loading" class="tw-text-center tw-w-full tw-opacity-80 tw-py-40">
      <h2>กำลังโหลดเอกสาร...</h2>
    </div> -->
    <v-progress-linear indeterminate color="green" :active="loading || downloadPdfLoading"></v-progress-linear>
    <v-container fluid class="tw-p-4">
      <!-- <v-divider class="tw-pb-4" /> -->
      <div v-if="submitable" class="tw-grid tw-grid-cols-1 tw-pt-2 tw-gap-2 tw-max-w-xs">
        <div class="tw-flex tw-justify-between">
          <div class="tw-font-bold ">Submit รายการภาษีมูลค่าเพิ่ม</div>
          <div>เลือก {{ selectedListLength }} ฉบับ</div>
        </div>
        <div>
          <v-select  :menu-props="{ top: false, offsetY: true, 'allow-overflow': true }" label="เลือกเดือนที่ยื่นภาษี" :items="hierarchicalPeriods" item-text="name" item-value="id"
            v-model="selectedPeriod" return-object ref="selectMenu" outlined dense hide-details
            >
            <template v-slot:item="{ item, props }">
              <v-list-item v-bind="props" :class="getColorClass(item)" :disabled="item.level === 0 || item.level === 1"
                @click="handleTimePeriodSelectionAndCloseMenu(item)">
                <v-list-item-title :style="{ fontWeight: item.level === 0 ? 'bold' : 'normal' }">
                  <span :style="{ 
                paddingLeft: `${item.level * 20}px`, 
                opacity: 1,
                color: item.level === 0 ? '#1976D2' : 'black',
                fontWeight: item.level === 0 ? 'bold' : 'normal'
              }">{{
                    item.name
                  }}</span>
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-select>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-gap-4">
          <v-btn color="primary" class="white--text" @click="sumitDocDialog = true" style="font-size: 14px"
            :disabled="selectedListLength === 0">
            <template v-slot:default> Submit </template>
          </v-btn>
          <v-btn color="red darken-1" class="white--text" @click="cancelDocDialog = true" style="font-size: 14px"
            :disabled="selectedListLength === 0">
            <template v-slot:default> CanCel Submit </template>
          </v-btn>
        </div>
      </div>

      <!-- Buttons Row -->
    </v-container>
    <v-dialog v-model="sumitDocDialog" width="380">
      <v-card>
        <v-card-title class="tw-text-xl">Submit รายการภาษีมูลค่าเพิ่มที่เลือก</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="tw-mr-4" text @click="sumitDocDialog = false">Close</v-btn>
          <v-btn color="green darken-1" text @click="handleSubmitDocClick()">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cancelDocDialog" width="380">
      <v-card>
        <v-card-title class="tw-text-xl">Cancel Submit รายการภาษีมูลค่าเพิ่มที่เลือก</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="tw-mr-4" text @click="cancelDocDialog = false">Close</v-btn>
          <v-btn color="red darken-1" text @click="handleCancelDocClick()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackBarError" color="red" top timeout="3000">
      <span class="tw-text-center tw-block">{{ snackBarMsg }}</span>
    </v-snackbar>
    <v-snackbar v-model="snackBarSuccess" color="green" top timeout="3000">
      <span class="tw-text-center tw-block">{{ snackBarMsg }}</span>
    </v-snackbar>
  </v-card>
  </div>
</template>

<script>
import Vue, {toRaw} from "vue";
import { mapState } from "vuex";
import fc from "@/firebaseConfig";
import firebase from "firebase/app";
import "firebase/auth";
import isMobile from "../../../libs/detectMobile";
import moment from "moment";
import "moment/locale/th";
// import PopoverMenu from "./popoverMenu";
import formatTwoDecimal from "@/libs/formatTwoDecimal";
import getErrorMessage from "@/libs/getErrorMessage";
import companyStatus from "@/libs/companyStatus";
import router from "@/router";
import getDocumentTypeKey from "@/libs/getDocumentTypeKey";
import libCSV from "@/libs/libCSV";
import MonthlyDownloadDialog from "./monthly-download-dialog.vue";
import Papa from "papaparse";
import thaismartTaxDetail from "@/store/collection/tax-detail-store";
import * as XLSX from "xlsx";
const axios = require("axios");
const _ = require("lodash");
import { getHierarchicalPeriods } from "@/libs/getPerioid";
const MAX_DOC_PER_ZIP = {
  xml: 500,
  pdf: 100,
};

moment.locale("th");

export default {
  components: {
    // PopoverMenu,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      menu: false,
      filterData: {
        branchID: "",
        taxCodeTypes: {
        },
        submitStatus: "",
        transactionStatus: "",
        payeeName: "",
        ivType: "",
        fromDate: "",
        toDate: "",
      },
      selectedFilter: {
        fromDateToDate: true,
        companyBranch: true,
        taxCondition: true,
        fromNoToNo: true,
        // transactionid: true,
      },
      filterOptions: [
        { key: "fromDateToDate", label: "วันที่เอกสาร" },
        { key: "companyBranch", label: "สาขากิจการ" },
        { key: "taxCondition", label: "ประเภทภาษี" },
        { key: "fromNoToNo", label: "เลขที่เอกสาร" },
        // { key: "transactionid", label: "ถึงเลขที่เอกสาร" },
      ],
      filterValueList: [
        "fromDateToDate",
        "companyBranch",
        "taxCondition",
        "fromNoToNo",
        // "transactionid",
      ],
      defaultFilterValueList: [
      ],

      companyID: this.$route.params.companyId,
      fromDateMenu: false,
      fromDateVal: null,
      minDateTax: null,
      minDate: "1990-01-05",
      maxDate: new Date(),
      toDateMenu: false,
      toDateVal: null,
      minDateToDate: this.fromDateVal,
      //check file
      // template import data
      selectedTemp: "template-1",
      temp1Hiden: false,
      template1: null,
      templateh: null,
      templatel: null,
      temp2Hiden: true,
      //end template import data
      selectedAll: false,
      emailDialog: false,
      taxRisDialog: false,
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      emailValid: false,
      taxRisValid: false,
      sendEmailLoading: false,
      isExportExcelLoading: false,
      sendEmailSuccessCount: 0,
      mEmailTemplateID: "Default Template",
      mEmailTemplatesListUnsubscribeObject: null,
      mEmailTemplatesList: [],
      mEmailTemplatesIDList: [],
      alert: {
        text: "",
        type: "success",
        show: false,
        showOnDialog: false,
      },

      pdfDialog: false,
      pdfSrc: "",
      downloadPdfLoading: false,
      clearingDownloadedXml: false,
      optionFilterList: [
        { label: "ดาวน์โหลดแล้ว", key: "@DownloadedXml" },
        { label: "ยังไม่ได้ดาวน์โหลด", key: "not-download" },
        { label: "เอกสารที่ยกเลิก", key: "cancelled" },
      ],
      defaultValueFilterList: ["@DownloadedXml", "not-download", "cancelled"],
      optionHideList: [
        { label: "แสดงทั้งหมด", key: "all" },
        { label: "ประเภทเอกสาร", key: "taxCondition" },
        { label: "เลขที่ใบกำกับภาษี", key: "taxInvoiceID" },
        { label: "วันที่", key: "docTaxDate" },
        { label: "ชื่อ", key: "customerName" },
        { label: "เลขประจำตัวผู้เสียภาษี", key: "customerTaxId" },
        { label: "สาขา", key: "customerBranch" },
        { label: "รหัสภาษีมูลค่าเพี่ม", key: "taxCode" },
        { label: "มูลค่าสินค้า/บริการ", key: "taxSumBaseAmount" },
        { label: "ภาษีมูลค่าเพิ่ม", key: "taxSumAmount" },
        { label: "รวมทั้งหมด", key: "taxDoctotal" },
        { label: "ประเภทภาษี", key: "taxCondition" },
        { label: "Origin Type", key: "@DocType" },
        { label: "เลขที่ใบรับเงิน", key: "paymentID" },

        { label: "ลิงก์", key: "link" },
      ],
      valueHideList: [
        "all",
        "taxCondition",
        "taxInvoiceID",
        "docTaxDate",
        "customerName",
        "customerTaxId",
        "customerBranch",
        "taxCode",
        "taxSumBaseAmount",
        "taxSumAmount",
        "taxDoctotal",
        "taxCondition",
        "@DocType",
        "paymentID",
        "link",
      ],
      defaultValueHideList: [
        "all",
        "taxCondition",
        "taxInvoiceID",
        "docTaxDate",
        "customerName",
        "customerTaxId",
        "customerBranch",
        "taxCode",
        "taxSumBaseAmount",
        "taxSumAmount",
        "taxDoctotal",
        "taxCondition",
        "@DocType",
        "paymentID",
        "link",
      ],
      searchOptionList: [
        { label: "ประเภทเอกสาร", key: "taxCondition" },
        { label: "เลขที่เอกสาร", key: "taxInvoiceID" },
        { label: "วันที่", key: "docTaxDate" },
        { label: "ชื่อ", key: "customerName" },
        { label: "เลขประจำตัวผู้เสียภาษี", key: "customerTaxId" },

        //{ label: "เวลาลงลายมือชื่อ", key: "@TimeSignedXml" },
      ],
      payeeTypeOptions: [
        { key: "S", value: "D : Vat Due" },
        { key: "P", value: "D : Vat Due" },
      ],
      defaultSearchOptionValue: "taxInvoiceID",
      disablePopOver: false,
      mouse: false,
      dragging: false,
      height: 0,
      resize: false,
      //filter
      filter: {
        issueDateTimeRange: [],
        objectId: "",
        scttAhtaBtpId: "",
        buyerBranchId: "",

        typeLineTotal: "",
        lineTotal: [],

        typeTaxTotal: "",
        taxTotal: [],

        typeGrandTotal: "",
        grandTotal: [],

        timeSignedXmlRange: [],
        docType: "",
        status: {
          downloadedXml: null,
          signSuccess: null,
          missingInfo: null,
          mailSent: null,
          suspendedAccount: null,
          buyerEmail_Isnull: null,
        },
      },
      branchTax: [
        { code: "1", description: "00000" },
        { code: "2", description: "00001" },
        { code: "3", description: "00002" },
      ],

      // selectbranchTax: "1",


      transactionStatusList: [
        { code: "All", description: "All" },
        { code: "Complete", description: "Complete" },
        { code: "Cancel", description: "Cancel" },
      ],

      selectStatusDocument: "1",



      statusSubmit: [
        { code: "All", description: "All" },
        { code: "Submit", description: "Submit" },
        { code: "Not Submit", description: "Not Submit" },
      ],

      formatInvoice: [
        { code: "All", description: "All" },
        { code: "Tax Invoice", description: "Tax Invoice" },
        { code: "Abbreviated Tax Invoice", description: "Abbreviated Tax Invoice" }
      ],

      selectformatInvoices: "1",

      timeSelection: "dateRange", // Default to date range
      timeOptions: [
        { value: "dateRange", text: "ช่วงวันที่ (Date Range)" },
        { value: "yearMonth", text: "ปี/เดือน (Year/Month)" },
      ],

      fromDate: "",
      toDate: "",

      menu1: false,
      selectedYearMonth: "",
      monthMenu: false, // Menu visibility
      monthVal: null,   // Selected value (YYYY-MM)

      // pagination
      pageInfo: null,
      totalCount: 0,
      edgeCount: 0,
      page: 1,
      itemsPerPage:
        localStorage.getItem("pageLimit") === "auto"
          ? "10"
          : localStorage.getItem("pageLimit"), // hardcode for auto case
      first:
        localStorage.getItem("pageLimit") === "auto"
          ? "10"
          : localStorage.getItem("pageLimit"),
      after: null,
      last: null,
      before: null,
      hasNextPage: null,
      hasPreviousPage: null,
      startCursor: null,
      endCursor: null,
      showPagination: false,

      // gql
      skipQuery: true,

      // email
      emailList: {},
      taxRisList: [],
      emailInput: "",
      awaitingDrag: false,
      timer: false,
      sentEmailHover: false,
      sentTaxRisHover: false,
      // export
      menuDatePickerStart: false,
      menuDatePickerEnd: false,
      exportDialog: false,
      dateExportStart: "",
      dateExportEnd: "",

      // monthly pdf
      monthlyDownloadDialog: false,
      exportEmailStatusRadios: "All",
      importDialog: false,
      importFile: [],
      importFileTemp2: [],
      importFileTemp2Head: [],
      importFileTemp2Line: [],

      //
      branchList: [],
      selectedPeriod: "",
      sumitDocDialog: false,
      cancelDocDialog: false,
      selectedTimePeriod: null,
      //
      snackBarMsg: "",
      snackBarError: false,
      snackBarSuccess: false,
      hierarchicalPeriods: getHierarchicalPeriods(2023, (new Date()).getFullYear()),
      // ui
      listByStatus: this.$route.name,
      headerTitle: "ภาษีขาย"
    };
  },
  mounted() {
    this.setTaxCondition(this);
    this.query();
  },
  created() {

    let resizeId;
    window.addEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.handleResize, 100);
    });
    this.handleResize();
    this.loadEmailTemplateList();
    this.getTaxWHBranch()
    this.getTimePeriods();
    //this.$store.dispatch("thaismartTaxDetail/fetchTaxBranch", {companyId: this.companyID});
    this.$store.dispatch("thaismartTaxDetail/getTaxCodes", { companyId: this.companyID });
  },
  beforeDestroy() {
    this.$store.dispatch("thaismartTaxDetail/getDocListUnsubscribe");
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    ...mapState({
      docs: (state) => state.thaismartTaxDetail.list,
      docsOrigin: (state) => state.thaismartTaxDetail.listOrigin,
      loading: (state) => state.thaismartTaxDetail.loading,
      keyword: (state) => state.thaismartTaxDetail.keyword,
      downloaded: (state) => state.docsDownloaded.downloaded,
      downloadingXml: (state) => state.docsDownloaded.downloadingXml,
      downloadingPdf: (state) => state.docsDownloaded.downloadingPdf,
      downloadStatus: (state) => state.docsDownloaded.downloadStatus,
      selectedBranch: (state) => state.companies.selectedBranch,
      orderBySelect: (state) => state.thaismartTaxDetail.orderBySelect,
      valueFilterList: (state) => state.thaismartTaxDetail.valueFilterList,
      selectedList: (state) => state.thaismartTaxDetail.selectedList,
      showPaginationTemplate: (state) =>
        state.thaismartTaxDetail.showPaginationTemplate,
      companyStatus: (state) => state.statusesByCompany.companyStatus,
      globalLoading: (state) => state.loading.globalLoading,
      // summaryAll: (state) => state.docs.summaryAll,
      taxBranch: (state) => state.thaismartTaxDetail.companyBranch,
      taxWHBranch: (state) => state.thaismartTaxDetail.taxWHBranch,
      periods: (state) => state.thaismartTaxDetail.timePeriodsList,
      vatCodes: (state) => state.thaismartTaxDetail.taxCodes?.filter(function (i) {
        if (state.thaismartTaxDetail.taxCondition === "Cancel") {
          return i.excludefromtaxreports === "F"
        }
        if (state.thaismartTaxDetail.taxCondition === "avg") {
          return i.available === 'P' && i.excludefromtaxreports === "F" && (i?.avgtax === "T" || false)
        }
        if (state.thaismartTaxDetail.taxCondition === "P") {
          return i.available === 'P' && i.excludefromtaxreports === "F" && (!i?.avgtax || i.avgtax === "F") 
        }
        if (state.thaismartTaxDetail.taxCondition === "S") {
          return i.available === 'S' && i.excludefromtaxreports === "F" && (!i?.avgtax || i.avgtax === "F")
        }

        return i.available === state.thaismartTaxDetail.taxCondition && i.excludefromtaxreports === "F"
      }),
      taxCoditon: (state) => state.thaismartTaxDetail.taxCondition,
      isLoading: (state) => state.thaismartTaxDetail.isLoading,
      submitable: (state) => state.thaismartTaxDetail.taxCondition !== "Cancel"
    }),
    fromDateDisp() {
      return this.fromDateVal;
      // format/do something with date
    },
    toDateDisp() {
      return this.toDateVal;
      // format/do something with date
    },
    minToDate() {
      // Calculate the minimum date (fromDateDisp + 1 day)
      const minDate = new Date(this.fromDateDisp);
      minDate.setDate(minDate.getDate());
      return minDate.toISOString().substr(0, 10);
    },
    monthDisp() {
      return this.monthVal;
      // format/do something with date
    },
    selectedListLength() {
      return this.selectedList.length;
    },
  },

  watch: {
    defaultSearchOptionValue: {
      handler: function () {
        this.$store.dispatch("thaismartTaxDetail/setFromDate", "");
        this.$store.dispatch("thaismartTaxDetail/setToDate", "");
        this.$store.dispatch("thaismartTaxDetail/updateKeyword", "");
        this.clearValue();
        this.clearSelectList();
        this.fromDateVal = null;
        this.toDateVal = null;
        this.query();
      },
    },
    selectedBranch: {
      handler: function () {
        this.query();
      },
    },
    fromDateVal: {
      handler: function (val) {
        this.filterData.fromDate = this.fromDateVal;
        if (!val) {
          this.toDateVal = null;
        }
      },
    },
    toDateVal: {
      handler: function () {
        this.filterData.toDate = this.toDateVal;
      },
    },
    selectedFilter: {
      handler: function (val) {
        if (!val.fromDateToDate) {
          this.filterData.fromDate = "";
          this.filterData.toDate = "";
        } else if (!val.branchID) {
          this.filterData.companyBranch = "";
        } else if (!val.taxCondition) {
          this.filterData.taxCondition = "";
        } else if (!val.fromNoToNo) {
          this.filterData.fromNo = "";
          this.filterData.toNo = "";
        } else if (!val.transactionid) {
          this.filterData.transactionid = "";
        }
        this.query()
      },
      deep: true,
    },
    $route: {
      handler: function() {
        this.clearValue();
        this.setTaxCondition(this);
        this.query();
      },
      deep: true,
      immediate: true
    },
    valueFilterList: {
      handler: function () {
        this.query();
      },
    },
    selectedList: {
      handler: function () {
        // this.checkSelectedAll();
      },
    },
    docs: {
      handler: function () {
        // this.checkSelectedAll();
      },
    },
    height: {
      handler: function () {
        this.matchHeight();
      },
    },
    taxWHBranch: {
      handler: function () {
        const obj = this.taxWHBranch.branch || [];
        this.branchList = obj.map((item) => {
          return item.code;
        });
      },
    },
    "$props.currentPage": {
      handler: function () {
        this.selectedAll = false;
      },
      immediate: true,
      deep: true
    },
  },

  methods: {
    async exportExcel() {
      console.log('exportExcel:');
      this.isExportExcelLoading = true;
      try {
        // Filter data to only include items with a valid docID
        const filteredData = this.docs.filter((x) => x["documentID"] && (this.selectedList.length === 0 || this.getCheckedSelect(x["documentID"])));
        if (filteredData.length === 0) {
          return;
        }

        const headerMapping = {
          "No.": "No.",
          "ประเภทเอกสาร": "transactionType",
          "เดือนที่ยื่นเอกสาร": "submitPeriod",
          "เลขที่ใบกำกับภาษี ": "taxInvoiceID",
          "วันที่ใบกำกับภาษี": "docTaxDate",
          "ชื่อผู้ซื้อสินค้า/ผู้รับบริการ": "customerName",
          "เลขประจำตัวผู้เสียภาษี": "customerTaxId",
          "สาขาคู่ค้า": "customerBranch",
          "รหัสภาษีมูลค่าเพิ่ม": "taxCode",
          "มูลค่าสินค้า/บริการ": "taxSumBaseAmount",
          "ภาษีมูลค่าเพิ่ม": "taxSumAmount",
          "รวมทั้งหมด": "taxDoctotal",
          // "ลิงก์": "link",
        };

        const headers = Object.keys(headerMapping);
        const formatData = filteredData.map((item, index) => {
          const obj = {};
          headers.forEach((header) => {
            const key = headerMapping[header];
            if (key === "submitPeriod") {
              obj[header] = this.displayThaiMonthAndYear(item[key], item);
            } else if (key === "No.") {
              obj[header] = index + 1;
            } else if (key === "docTaxDate") {
              obj[header] = this.formatDate2(item[key]);
            } else {
              obj[header] = item[key] || "";
            }
          });
          return obj;
        });

        const worksheet = XLSX.utils.json_to_sheet(formatData, {
          header: headers,
        });
        const workbook = XLSX.utils.book_new();
        const prefix = (function (context){
          if (context.taxCoditon === "Cancel") {
            return "TaxCancel"
          } else if (context.taxCoditon === "P") {
            return "TaxPurchase"
          } else if (context.taxCoditon === "avg") {
            return "TaxPurchaseAvg"
          } else {
            return "TaxSale"
          }
        })(this)
        XLSX.utils.book_append_sheet(workbook, worksheet, prefix);
        const fileName = `${prefix}_${new Date()
          .toISOString()
          .slice(0, 10)}.xlsx`;
        XLSX.writeFile(workbook, fileName);

        // Reset selected list
        this.clearSelectList();
      } catch (error) {
        console.log('error:', error);
      } finally {
        this.isExportExcelLoading = false;
      }
    },
    loadEmailTemplateList() {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        if (this.mEmailTemplatesListUnsubscribeObject) {
          this.mEmailTemplatesListUnsubscribeObject();
        }
        this.mEmailTemplatesListUnsubscribeObject = fc.db
          .collection(`Companies/${companyId}/EmailTemplates`)
          .onSnapshot((docs) => {
            this.mEmailTemplatesList = [];
            this.mEmailTemplatesIDList = ["Default Template"];

            docs.forEach((doc) => {
              const data = doc.data();
              console.log("hello ===>",data)
              data.id = doc.id;
              this.mEmailTemplatesList.push(data);
              this.mEmailTemplatesIDList.push(data.id);
            });
            // console.log(this.mEmailTemplatesList)
          });
      }
    },
    startDrag() {
      this.timer = false;
      this.dragging = false;
      this.mouse = true;
    },
    stopDrag(doc) {
      if (!this.dragging && this.mouse) {
        // this.onClickDocId(doc['@SignedPdfUrl'])
        this.onClickDocId(doc);
      }
      this.dragging = false;
      this.mouse = false;
    },
    doDrag() {
      if (this.mouse && !this.awaitingDrag) {
        this.timer = setTimeout(() => {
          this.dragging = true;
          this.awaitingDrag = false;
        }, 200);
        this.awaitingDrag = true;
      }
    },
    matchHeight() {
      if (localStorage.getItem("pageLimit") !== "auto") return;
      let cardTitle = document.getElementById("card-title")?.clientHeight || 0;
      let headerTable =
        document.getElementById("header-table")?.clientHeight || 0;
      let rowDetailRow = Math.floor(
        (this.height - (150 + cardTitle + headerTable)) / 67
      );
      let pageLimit = 10;
      pageLimit =
        rowDetailRow > 1
          ? rowDetailRow - 1
          : rowDetailRow >= 0
            ? rowDetailRow
            : 1;

      localStorage.setItem("pageLimitAuto", pageLimit.toString());
      this.$store.dispatch("user/setPageLimitAutoChange");
      this.clearValue();
      this.query();
    },
    handleResize() {
      this.height = window.innerHeight;
    },
    getTaxId: function (taxID, companyID) {
      if (!taxID || taxID == "N/A")
        return companyID == "XMigdx2tCoT0CD4JDkGN" ||
          companyID == "0m2cwidBErAKMf2I9vkT"
          ? ""
          : "N/A";
      let taxIDShow = "-";
      if (taxID.length > 13) {
        taxIDShow = taxID.substring(0, 13);
      } else if (taxID.length <= 13) {
        taxIDShow = taxID;
      }
      return taxIDShow;
    },
    getCheckedSelect: function (transactionid) {
      return this.selectedList.some((x) => x["documentID"] === transactionid);
    },
    getFormatAmount(amount) {
      return formatTwoDecimal(amount);
    },
    getFormatToNumber(strr) {
      return Number(strr) || 0;
    },
    formatCurrency(value) {
      if (value == null || isNaN(value)) return "0.00";
      return parseFloat(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    timeFormat: function (timestamp) {
      if (timestamp) {
        return moment(timestamp.toDate())
          .add(543, "years")
          .format("Do MMM YY, LTS");
      }
      return "-";
    },
    query: function () {
      this.$store.dispatch("thaismartTaxDetail/setFilterData", {
        ..._.cloneDeep(this.filterData),
      });
      let companyId = this.$route.params.companyId;

      if (companyId) {
        this.$store.dispatch("thaismartTaxDetail/getList", {
          id: companyId,
          selectedBranch: this.selectedBranch,
        });
      }
    },
    getEmailList: function () {
      for (let e of this.selectedList) {
        if (e.transactionid) {
          if (!this.emailList[e.transactionid]) {
            this.emailList[e.transactionid] = [];
          }
          if (e.buyerEmail) {
            this.emailList[e.transactionid] = Vue.observable(
              e.buyerEmail.replaceAll(";", ",").split(",")
            );
          } else {
            this.emailList[e.transactionid] = Vue.observable([]);
          }
        }
      }
    },

    clearEmailList: function () {
      this.emailDialog = false;
      this.emailList = {};
    },

    getDocumentType() {
      let documentType = router.currentRoute.name.split(".");
      if (documentType.length > 2) {
        return documentType[documentType.length - 1];
      }
      return "";
    },
    // getDocsByRange(timeStart, timeEnd) {
    //   const companyID = this.$route.params.companyId;
    //   let documentType = this.getDocumentType();
    //   // console.log("documentType:: ", documentType);
    //   let documentTypeNumber = getDocumentTypeKey(documentType);
    //   // console.log(documentType, documentTypeNumber);

    //   let q = fc.db.collection(`Companies/${companyID}/Docs`);
    //   if (documentTypeNumber) {
    //     q = q.where("@DocType", "==", documentTypeNumber);
    //   }
    //   q = q.where(
    //     new firebase.firestore.FieldPath("ED.IssueDateTime.Timestamp"),
    //     ">=",
    //     timeStart.toDate()
    //   );
    //   q = q.where(
    //     new firebase.firestore.FieldPath("ED.IssueDateTime.Timestamp"),
    //     "<",
    //     timeEnd.toDate()
    //   );
    //   q = q.orderBy(
    //     new firebase.firestore.FieldPath("ED.IssueDateTime.Timestamp")
    //   );
    //   return q.get();
    // },
    exportDocs() {
      const timeStart = moment(this.dateExportStart + "T00:00:00.000+07:00");
      const timeEnd = moment(this.dateExportEnd + "T00:00:00.000+07:00").add(
        1,
        "days"
      );
      const filterEmailStatus = this.exportEmailStatusRadios;
      this.getDocsByRange(timeStart, timeEnd).then((querySnapshot) => {
        const rows = [
          [
            "วันที่เอกสาร", // ED.IssueDateTime
            "เลขที่เอกสาร", // objectID
            "รหัสผู้ซื้อ", // SCTT.AHTA.BTP.ID
            "ชื่อผู้ซื้อ/ชื่อบริษัท", // SCTT.AHTA.BTP.Name
            "เลขผู้เสียภาษี", // SCTT.AHTA.BTP.STR.ID
            "สาขาผู้ซื้อ", // @BuyerBranchID
            "มูลค่าที่นำมาคิดภาษี", // SCTT.AHTS.STSHMS.TaxBasisTotalAmount
            "ภาษีมูลค่าเพิ่ม", // SCTT.AHTS.STSHMS.TaxTotalAmount
            "ยอดรวม", // SCTT.AHTS.STSHMS.GrandTotalAmount
            "สถานะการส่งอีเมล", // @MailSent
            "เวลาการส่งอีเมล", // @TimeMailSent
          ],
        ];
        querySnapshot.forEach((doc) => {
          const data = doc.data();

          // filter by send email status
          if (filterEmailStatus !== "All") {
            if (
              (filterEmailStatus === "Sent" && !data["@MailSent"]) ||
              (filterEmailStatus === "NotSent" && data["@MailSent"])
            ) {
              return;
            }
          }

          rows.push([
            data["ED.IssueDateTime"].split("T")[0],
            data["objectID"],
            data["SCTT.AHTA.BTP.ID"],
            data["SCTT.AHTA.BTP.Name"],
            this.getTaxId(data["SCTT.AHTA.BTP.STR.ID"]),
            data["@BuyerBranchID"],
            libCSV.stangToTHB(data["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"]),
            libCSV.stangToTHB(data["SCTT.AHTS.STSHMS.TaxTotalAmount"]),
            libCSV.stangToTHB(data["SCTT.AHTS.STSHMS.GrandTotalAmount"]),
            data["@MailSent"] ? "Y" : "N",
            data["@TimeMailSent"]
              ? moment(data["@TimeMailSent"].toDate()).format(
                "YYYY-MM-DDTHH:mm:ss"
              )
              : "",
          ]);
        });
        libCSV.exportCSV(
          `Docs_${this.dateExportStart}_${this.dateExportEnd}.csv`,
          rows
        );
        this.exportDialog = false;
      });
    },
    cancelExportDialog() {
      this.exportDialog = false;
    },

    handleImportFile(e) {
      if (e.type != "text/csv") {
        this.alert = {
          text: "ไมสามารถอ่านข้อมูลได้ กรุณาเลือกไฟล์ CSV",
          type: "error",
          show: true,
          showOnDialog: true,
        };
        this.$refs.importFileRef.reset();
      } else {
        if (e) {
          Papa.parse(e, {
            header: false,
            skipEmptyLines: true,
            complete: function (results) {
              this.importFile = results;
              // this.parsed = true;
            }.bind(this),
          });
        }
      }
    },
    // handleImportFileTemp2
    handleImportFileTemp2(type, e) {
      // check type file
      if (e.type != "text/csv") {
        this.alert = {
          text: "ไมสามารถอ่านข้อมูลได้ กรุณาเลือกไฟล์ CSV",
          type: "error",
          show: true,
        };

        this.$refs.importFileRefH.reset();
        this.$refs.importFileRefL.reset();
        // this.alertFile = true;
        // console.log("Hey!! get out"+e.type)
      } else {
        switch (type) {
          case "head":
            if (e) {
              Papa.parse(e, {
                header: false,
                skipEmptyLines: true,
                complete: function (results) {
                  this.importFileTemp2Head = results;
                  // this.parsed = true;
                }.bind(this),
              });
            }
            break;
          case "line":
            if (e) {
              Papa.parse(e, {
                header: false,
                skipEmptyLines: true,
                complete: function (results) {
                  this.importFileTemp2Line = results;
                }.bind(this),
              });
            }
            break;
        }
      }
    },
    async importDocs() {
      let csvData = [];
      var ret = [];
      try {
        switch (this.selectedTemp) {
          case "template-1":
            if (
              this.importFile.data < 0 ||
              typeof this.importFile.data === "undefined" ||
              this.importFile.data == 0 ||
              this.importFile.data == null
            ) {
              this.alert = {
                text: "กรุณาเลือกไฟล์ CSV",
                type: "error",
                show: true,
              };
            }

            for (var i = 1; i < this.importFile.data.length; i++) {
              var temp = this.importFile.data[i];
              var obj = {
                docType: temp[0],
                sellerName: temp[1],
                sellerAddress: temp[2],
                sellerTaxID: temp[3],
                sellerBranchID: temp[4],
                buyerID: temp[5],
                buyerName: temp[6],
                buyerTaxID: temp[7],
                buyerAddress: temp[8],
                buyerBranchID: temp[9],
                buyerEmail: temp[10],
                buyerOrderRefDoc: temp[11],
                issuerAssignedID: temp[12],
                FissueDate: temp[13],
                typeCode: temp[14],
                transactionid: temp[15],
                issueDate: temp[16],
                creationDate: temp[17],
                noteSubject: temp[18],
                reference: temp[19],
                additionalRefDocs: temp[20],
                LissuerAssignedID: temp[21],
                LissueDate: temp[22],
                LtypeCode: temp[23],
                currency: temp[24],
                vat: temp[25],
                line: temp[26],
                discount: temp[27],
                basis: temp[28],
                tax: temp[29],
                total: temp[30],
                originalinformationamount: temp[31],
                differenceInformationAmount: temp[32],
                purposeCode: temp[33],
                purpose: temp[34],
                items: temp[35],
                productID: temp[36],
                description: temp[37],
                price: temp[38],
                unit: temp[39],
                quantity: temp[40],
                Lvat: temp[41],
                Ldiscount: temp[42],
                Lbasis: temp[43],
                Ltax: temp[44],
                Ltotal: temp[45],
                baseInvoiceAmount: temp[46],
                docDueDate: temp[47],
                paymentTermsCode: temp[48],
                customerVendorRef: temp[49],
                downPaymentAmount: temp[50],
                tel1: temp[51],
                tel2: temp[52],
                fax1: temp[53],
                salesEmployeeName: temp[54],
                contactPersonName: temp[55],
                baseRefNo: temp[56],
                baseRefDate: temp[57],
                crReason1: temp[58],
                crReason2: temp[59],
                drReason1: temp[60],
                drReason2: temp[61],
                payBy: temp[62],
                domain: temp[63],
                allowancePercent: temp[64],
              };
              csvData.push(obj);
            }
            var tempCustomer = {};
            for (i = 0; i < csvData.length; i++) {
              var item = csvData[i];
              if (item.sellerName) {
                if (i > 0) {
                  ret.push(tempCustomer);
                }
                tempCustomer = item;
                tempCustomer.items = [];
              } else {
                tempCustomer.items.push(item);
              }
            }

            if (tempCustomer) {
              ret.push(tempCustomer);
            }
            break;
          case "template-2":
            var arrHead = [];
            var arrLine = [];
            if (
              this.importFileTemp2Head.data < 0 ||
              typeof this.importFileTemp2Head.data === "undefined" ||
              this.importFileTemp2Head.data == 0 ||
              this.importFileTemp2Head.data == null
            ) {
              this.alert = {
                text: "กรุณาเลือกไฟล์ CSV ส่วนหัว",
                type: "error",
                show: true,
              };
            } else if (
              this.importFileTemp2Line.data < 0 ||
              typeof this.importFileTemp2Line.data === "undefined" ||
              this.importFileTemp2Line.data == 0 ||
              this.importFileTemp2Line.data == null
            ) {
              this.alert = {
                text: "กรุณาเลือกไฟล์ CSV ส่วนเนื้อใน",
                type: "error",
                show: true,
              };
            }
            // if (this.importFileTemp2Line.data < 0 || typeof this.importFileTemp2Line.data === 'undefined' || this.importFileTemp2Line.data == 0 || this.importFileTemp2Line.data == null) {
            //   this.alert2 = {
            //     text: "กรุณาเลือกไฟล์ CSV ส่วนเนื้อใน",
            //     type: "error",
            //     show: true
            //   };
            // }
            for (i = 1; i < this.importFileTemp2Head.data.length; i++) {
              var tempHead = this.importFileTemp2Head.data[i];
              var objHead = {
                docType: tempHead[0],
                sellerName: tempHead[1],
                sellerAddress: tempHead[2],
                sellerTaxID: tempHead[3],
                sellerBranchID: tempHead[4],
                buyerID: tempHead[5],
                buyerName: tempHead[6],
                buyerTaxID: tempHead[7],
                buyerAddress: tempHead[8],
                buyerBranchID: tempHead[9],
                buyerEmail: tempHead[10],
                buyerOrderRefDoc: tempHead[11],
                issuerAssignedID: tempHead[12],
                FissueDate: tempHead[13],
                typeCode: tempHead[14],
                transactionid: tempHead[15],
                issueDate: tempHead[16],
                creationDate: tempHead[17],
                noteSubject: tempHead[18],
                reference: tempHead[19],
                additionalRefDocs: tempHead[20],
                LissuerAssignedID: tempHead[21],
                LissueDate: tempHead[22],
                LtypeCode: tempHead[23],
                currency: tempHead[24],
                vat: tempHead[25],
                line: tempHead[26],
                discount: tempHead[27],
                basis: tempHead[28],
                tax: tempHead[29],
                total: tempHead[30],
                originalinformationamount: tempHead[31],
                differenceInformationAmount: tempHead[32],
                purposeCode: tempHead[33],
                purpose: tempHead[34],
                //line
                items: "",
                productID: "",
                description: "",
                price: "",
                unit: "",
                quantity: "",
                Lvat: "",
                Ldiscount: "",
                Lbasis: "",
                Ltax: "",
                Ltotal: "",
                //
                baseInvoiceAmount: tempHead[35],
                docDueDate: tempHead[36],
                paymentTermsCode: tempHead[37],
                customerVendorRef: tempHead[38],
                downPaymentAmount: tempHead[39],
                tel1: tempHead[40],
                tel2: tempHead[41],
                fax1: tempHead[42],
                salesEmployeeName: tempHead[43],
                contactPersonName: tempHead[44],
                baseRefNo: tempHead[45],
                baseRefDate: tempHead[46],
                crReason1: tempHead[47],
                crReason2: tempHead[48],
                drReason1: tempHead[49],
                drReason2: tempHead[50],
                payBy: tempHead[51],
                domain: tempHead[52],
                allowancePercent: temp[64],
              };
              arrHead.push(objHead);
            }

            for (i = 1; i < this.importFileTemp2Line.data.length; i++) {
              var tempLine = this.importFileTemp2Line.data[i];
              var objLine = {
                docType: "",
                sellerName: "",
                sellerAddress: "",
                sellerTaxID: "",
                sellerBranchID: "",
                buyerID: "",
                buyerName: "",
                buyerTaxID: "",
                buyerAddress: "",
                buyerBranchID: "",
                buyerEmail: "",
                buyerOrderRefDoc: "",
                issuerAssignedID: "",
                FissueDate: "",
                typeCode: "",
                transactionid: "",
                issueDate: "",
                creationDate: "",
                noteSubject: "",
                reference: "",
                additionalRefDocs: "",
                LissuerAssignedID: "",
                LissueDate: "",
                LtypeCode: "",
                currency: "",
                vat: "",
                line: "",
                discount: "",
                basis: "",
                tax: "",
                total: "",
                originalinformationamount: "",
                differenceInformationAmount: "",
                purposeCode: "",
                purpose: "",
                //line
                items: tempLine[1],
                productID: tempLine[2],
                description: tempLine[3],
                price: tempLine[4],
                unit: tempLine[5],
                quantity: tempLine[6],
                Lvat: tempLine[7],
                Ldiscount: tempLine[8],
                Lbasis: tempLine[9],
                Ltax: tempLine[10],
                Ltotal: tempLine[11],
                //
                baseInvoiceAmount: "",
                docDueDate: "",
                paymentTermsCode: "",
                customerVendorRef: "",
                downPaymentAmount: "",
                tel1: "",
                tel2: "",
                fax1: "",
                salesEmployeeName: "",
                contactPersonName: "",
                baseRefNo: "",
                baseRefDate: "",
                crReason1: "",
                crReason2: "",
                drReason1: "",
                drReason2: "",
                payBy: "",
                domain: "",
              };
              arrLine.push(objLine);
            }
            arrHead.forEach((listHead) => {
              var itemList = arrLine.filter(
                (arrLine) => arrLine.transactionid == listHead.transactionid
              );
              var obj2 = {
                docType: listHead.docType,
                sellerName: listHead.sellerName,
                sellerAddress: listHead.sellerAddress,
                sellerTaxID: listHead.sellerTaxID,
                sellerBranchID: listHead.sellerBranchID,
                buyerID: listHead.buyerID,
                buyerName: listHead.buyerName,
                buyerTaxID: listHead.buyerTaxID,
                buyerAddress: listHead.buyerAddress,
                buyerBranchID: listHead.buyerBranchID,
                buyerEmail: listHead.buyerEmail,
                buyerOrderRefDoc: listHead.buyerOrderRefDoc,
                issuerAssignedID: listHead.issuerAssignedID,
                FissueDate: listHead.FissueDate,
                typeCode: listHead.typeCode,
                transactionid: listHead.transactionid,
                issueDate: listHead.issueDate,
                creationDate: listHead.creationDate,
                noteSubject: listHead.noteSubject,
                reference: listHead.reference,
                additionalRefDocs: listHead.additionalRefDocs,
                LissuerAssignedID: listHead.LissuerAssignedID,
                LissueDate: listHead.LissueDate,
                LtypeCode: listHead.LtypeCode,
                currency: listHead.currency,
                vat: listHead.vat,
                line: listHead.line,
                discount: listHead.discount,
                basis: listHead.basis,
                tax: listHead.tax,
                total: listHead.total,
                originalinformationamount: listHead.originalinformationamount,
                differenceInformationAmount:
                  listHead.differenceInformationAmount,
                purposeCode: listHead.purposeCode,
                purpose: listHead.purpose,
                //line
                items: itemList,
                productID: "",
                description: "",
                price: "",
                unit: "",
                quantity: "",
                Lvat: "",
                Ldiscount: "",
                Lbasis: "",
                Ltax: "",
                Ltotal: "",
                //
                baseInvoiceAmount: listHead.baseInvoiceAmount,
                docDueDate: listHead.docDueDate,
                paymentTermsCode: listHead.paymentTermsCode,
                customerVendorRef: listHead.customerVendorRef,
                downPaymentAmount: listHead.downPaymentAmount,
                tel1: listHead.tel1,
                tel2: listHead.tel2,
                fax1: listHead.fax1,
                salesEmployeeName: listHead.salesEmployeeName,
                contactPersonName: listHead.contactPersonName,
                baseRefNo: listHead.baseRefNo,
                baseRefDate: listHead.baseRefDate,
                crReason1: listHead.crReason1,
                crReason2: listHead.crReason2,
                drReason1: listHead.drReason1,
                drReason2: listHead.drReason2,
                payBy: listHead.payBy,
                domain: listHead.domain,
              };
              ret.push(obj2);
            });
            break;
        }
        if (ret.length > 0) {
          let companyID = this.$route.params.companyId;
          await this.$store.dispatch("importDocs/importDocs", {
            docs: ret,
            companyID,
          });
          this.alert = {
            text: "นำเข้าข้อมูล สําเร็จ หน้าเว็บจะรีโหลดในอีก 3 วิ",
            type: "success",
            show: true,
            showOnDialog: true,
          };
          // setTimeout(()=> this.cancelImportDialog(),1000);
          setTimeout(() => window.location.reload(), 3000);
        }
      } catch (error) {
        // console.log("File import error " + error.toString());
        this.alert = {
          text: "นำเข้าข้อมูล ไม่สําเร็จ",
          type: "error",
          show: true,
          showOnDialog: true,
        };
      }
    },
    cancelImportDialog() {
      this.importDialog = false;
      this.importFile = [];
      this.template1 = null;
      this.templateh = null;
      this.templatel = null;
      this.alert = {
        text: "",
        type: "success",
        show: false,
        showOnDialog: false,
      };
      //this.$refs.importFileRef.value=null
    },
    clickSelectedAll: function (checked) {
      let selectedList = _.cloneDeep(this.selectedList);
      if (checked) {
        this.data.forEach((doc) => {
          if (
            !selectedList.some((x) => x["documentID"] === doc["documentID"]) && !(doc.items.filter(item => item.taxType == 2).length > 0 || doc.taxType == 2)
          ) {
            selectedList.push({
              companyID: this.companyID,
              "documentID": doc["documentID"],
              data: doc,
              pdfUrl: doc["@SignedPdfUrl"],
              xmlUrl: doc["@SignedXmlUrl"],
            });
            //console.log("selectedList",selectedList)
          }
        });
      } else {
        this.data.forEach((doc) => {
          let index = selectedList.findIndex(
            (x) => x["documentID"] === doc["documentID"]
          );
          if (index !== -1) {
            selectedList.splice(index, 1);
          }
        });
      }
      this.$store.dispatch("thaismartTaxDetail/setSelectedList", {
        selectedList: selectedList,
      });
    },
    clickSelected: function (doc) {
      let valueList = _.cloneDeep(this.selectedList);
      let docsWithSameTransactionId = this.data.filter(
        (x) => x.transactionid === doc["transactionid"]
      );
      if (this.getCheckedSelect(doc["documentID"])) {

        valueList = valueList.filter(
          (x) => x["transactionid"] !== doc["transactionid"]
        );
      } else {
        docsWithSameTransactionId.forEach((docWithSameId) => {
          valueList.push({
            companyID: this.companyID,
            "documentID": docWithSameId["documentID"],
            transactionid: docWithSameId["transactionid"],
            data: docWithSameId,
            pdfUrl: docWithSameId["@SignedPdfUrl"],
            xmlUrl: docWithSameId["@SignedXmlUrl"],
          });
        });
      }
      //console.log(valueList)
      this.$store.dispatch("thaismartTaxDetail/setSelectedList", {
        selectedList: valueList,
      });
    },
    checkSelectedAll: function () {
     this.selectedAll = this.selectedList.length > 0 && (this.selectedList.length == this.data.length || this.selectedList.every(doc => this.data.some(dataDoc => dataDoc.documentID === doc.documentID)));
    },
    debounceInput: _.debounce(function (keyword) {
      console.log("keyword : ", keyword)
      this.changeKeyword(keyword);
    }, 1000),
    changeKeyword: function (keyword) {
      this.clearValue();
      let companyId = this.$route.params.companyId;

      if (companyId) {
        // this.$store.dispatch("thaismartTax/updateKeyword", {
        //   id: companyId,
        //   keyword: keyword,
        // });
        this.filterData.customerName = keyword;
        this.onChangeValueSearchOption(this.filterData);
        let resizeId;
        window.addEventListener("resize", () => {
          clearTimeout(resizeId);
          resizeId = setTimeout(this.handleResize, 100);
        });
        this.handleResize();
      }
    },
    validateEmail: function () {
      if (this.$refs.form.validate()) {
        this.emailDialog = false;
        this.sendEmail();
      }
    },
    sendEmail: async function () {
      this.sendEmailLoading = true;

      // get user token
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      // let allEmailFill = (this.emailList.join(',').replaceAll(';',',')).split(",")
      // let allEmailSelected = (this.selectedList.map(select => {
      //   return select['buyerEmail'].replaceAll(';',',')
      // }))
      // allEmailSelected = (allEmailSelected.join(',')).split(',')
      // let emailWouldSend = []
      // for(let e of allEmailFill) {
      //   if(!allEmailSelected.includes(e)){
      //     emailWouldSend.push(e)
      //   }
      // }
      // const promises = this.selectedList.map(async (select) => {
      //   let allEmailSend = select['buyerEmail'].replaceAll(';',',')
      //   if(emailWouldSend.length>0){
      //     if(allEmailSend) {
      //       allEmailSend += ',' + emailWouldSend.join(',')
      //     }else{
      //       allEmailSend = emailWouldSend.join(',')
      //     }
      //   }
      //   let data = {
      //     company_id: this.$route.params.companyId,
      //     invoice_id: select['docID'],
      //     email: allEmailSend,
      //   }

      //   await axios.post(fc.cloudFunctionUrl + "sendemail", data, {headers})
      //     .then((response) => {
      //       if (response.status === 200) {
      //         this.sendEmailSuccessCount++
      //       }

      //     }, (error) => {
      //       console.log(error)
      //     });
      // })
      const promises = Object.keys(this.emailList).map(async (k) => {
        let data = {
          company_id: this.$route.params.companyId,
          invoice_id: k,
          email: this.emailList[k].join(","),
        };

        if (this.mEmailTemplateID != "Default Template") {
          data["emailTemplateID"] = this.mEmailTemplateID;
        }

        await axios
          .post(fc.cloudFunctionUrl + "sendemail", data, { headers })
          .then(
            (response) => {
              if (response.status === 200) {
                this.sendEmailSuccessCount++;
              }
            },
            (error) => {
              console.log(error);
            }
          );
      });

      await Promise.all(promises);
      if (this.sendEmailSuccessCount === this.selectedList.length) {
        this.alert = {
          text: "ส่งอีเมลสำเร็จ " + this.sendEmailSuccessCount + " รายการ",
          type: "success",
          show: true,
        };

        this.sendEmailSuccessCount = 0;

        this.query();
      }
      this.sendEmailLoading = false;
      this.emailDialog = false;
      this.email = "";
      this.emailList = {};
    },
    changeOrderBy: function (order) {
      let orderBySelect = _.cloneDeep(this.orderBySelect);
      if (!(this.orderBySelect["key"] === order)) {
        orderBySelect = { key: order, value: "asc" };
      } else {
        if (_.get(orderBySelect, "value") === "asc") {
          _.set(orderBySelect, "value", "desc");
        } else {
          orderBySelect = {};
        }
      }
      this.$store.dispatch("thaismartTaxDetail/setOrderBySelect", {
        orderBySelect: orderBySelect,
      });
      this.$store.dispatch("thaismartTaxDetail/updatePage", { page: 1 });
      this.query();
    },
    downloadPDF: function () {
      // console.log("tst");
      return;
      // zipFiles(this.$route.params.companyId, this.selected, "pdf", '@SignedPdfUrl', this.$store.dispatch)
      // this.downloadZip("pdf", this.selectedList, "pdf", MAX_DOC_PER_ZIP["pdf"]);
    },
    downloadMonthly: async function ({ month, fileType, filter }) {
      let maxPerZip = MAX_DOC_PER_ZIP[fileType] || 0;

      try {
        this.loadingDownloadZip("monthly", "on");
        this.setDownloadProgress("monthly", "");
        const startDate = moment(month).startOf("day");
        const endDate = moment(month).endOf("month").endOf("day");
        const snapshot = await this.getDocsByRange(startDate, endDate);

        let selected = [];
        snapshot.forEach((doc) => {
          const data = doc.data();
          selected.push({
            transactionid: doc.transactionid,
            pdfUrl: data["@SignedPdfUrl"],
            xmlUrl: data["@SignedXmlUrl"],
            downloadedXml: data["@DownloadedXml"],
          });
        });

        if (filter) {
          if (filter.downloadedXml === "Downloaded") {
            selected = selected.filter((doc) => doc.downloadedXml);
          } else if (filter.downloadedXml === "NotDownloaded") {
            selected = selected.filter((doc) => !doc.downloadedXml);
          }
        }

        await this.downloadZip(fileType, selected, "monthly", maxPerZip);
      } catch (err) {
        this.loadingDownloadZip("monthly", "off");
      }
    },
    downloadXML: function () {
      // zipFiles(this.$route.params.companyId, this.selected, "xml", '@SignedXmlUrl', this.$store.dispatch)
      this.downloadZip("xml", this.selectedList, "xml", MAX_DOC_PER_ZIP["xml"]);
    },
    loadingDownloadZip: function (type, onOff) {
      let boolean = onOff === "on";
      if (type === "xml")
        this.$store.dispatch("docsDownloaded/updateDownloadingXml", {
          downloadingXml: boolean,
        });
      else if (type === "pdf")
        this.$store.dispatch("docsDownloaded/updateDownloadingPdf", {
          downloadingPdf: boolean,
        });
      else
        this.$store.commit("docsDownloaded/setDownloading", {
          type: type,
          downloading: boolean,
        });
    },
    setDownloadProgress: function (type, progress) {
      this.$store.commit("docsDownloaded/setDownloadProgress", {
        type: type,
        progress: progress,
      });
    },
    downloadZip: async function (type, selected, loadingType, maxPerZip) {
      if (!loadingType) {
        loadingType = type;
      }

      this.loadingDownloadZip(loadingType, "on");
      let urlField = "pdfUrl";
      if (type === "xml") {
        urlField = "xmlUrl";
      }
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      let docList = [];
      let timeStamp = new Date().getTime();

      // เอาเฉพาะแถวที่มี url
      selected.forEach((docSelect) => {
        if (docSelect[urlField]) {
          docList.push({ id: docSelect["transactionid"], url: docSelect[urlField] });
        }
      });

      if (docList.length === 0) {
        this.loadingDownloadZip(loadingType, "off");
        this.alert = {
          text: "ไม่พบเอกสารที่ต้องการ",
          type: "error",
          show: true,
        };
        return;
      }

      if (!maxPerZip) {
        maxPerZip = docList.length;
      }

      const companyId = this.$route.params.companyId;
      const zipChunk = async function (chunk, startNumber) {
        const result = await axios.post(
          fc.cloudFunctionUrl + "zipFiles",
          { data: chunk, type: type, companyID: companyId },
          { headers, responseType: "arraybuffer" }
        );
        if (result.data.byteLength !== 0) {
          let url = URL.createObjectURL(
            new Blob([result.data], { type: "application/zip" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${timeStamp}_${startNumber}-${startNumber + chunk.length - 1}.zip`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
        }
      };

      // split documents into smaller chunks
      // then zip and download each
      let startNumber = 1;
      const total = docList.length;
      while (docList.length > 0) {
        try {
          const chunk = docList.splice(0, maxPerZip);
          this.setDownloadProgress(
            loadingType,
            `กำลังโหลด...(${startNumber - 1}/${total})`
          );
          await zipChunk(chunk, startNumber);
          startNumber += chunk.length;
        } catch (err) {
          console.log("front end error: ", err);
          this.alert = {
            text: "เกิดข้อผิดพลาดขณะดาวน์โหลด กรุณาลองอีกครั้ง",
            type: "error",
            show: true,
          };
          this.loadingDownloadZip(loadingType, "off");
          return;
        }
      }

      this.loadingDownloadZip(loadingType, "off");
      this.clearSelectList();
    },
    // clearDownloadedXml: async function () {
    //   this.clearingDownloadedXml = true;

    //   const companyID = this.$route.params.companyId;
    //   const list = this.selectedList.filter((doc) => doc.downloadedXml);
    //   const count = list.length;
    //   const batch = fc.db.batch();

    //   list.forEach((doc) => {
    //     const docRef = fc.db.doc(`Companies/${companyID}/Docs/${doc.docID}`);
    //     batch.update(docRef, {
    //       "@DownloadedXml": false,
    //     });
    //   });

    //   try {
    //     await batch.commit();
    //     this.alert = {
    //       text: "ยกเลิกค่าดาวน์โหลดสำเร็จ " + count + " รายการ",
    //       type: "success",
    //       show: true,
    //     };
    //   } catch (err) {
    //     console.error("clearDownloadedXml error: ", err);
    //     this.alert = {
    //       text: "เกิดข้อผิดพลาดขณะยกเลิกค่าดาวน์โหลด กรุณาลองอีกครั้ง",
    //       type: "error",
    //       show: true,
    //     };
    //   }

    //   this.clearSelectList();
    //   this.clearingDownloadedXml = false;
    // },
    // onClickDocId: async function (doc) {
    //   this.$store.dispatch("setGlobalLoading", true);
    //   this.downloadPdfLoading = true;

    //   let pdfLink = doc["@PdfUrl"];
    //   // console.log("Doc Clicked, PDF LINK::  ", pdfLink);
    //   if (!pdfLink) {
    //     this.alert = {
    //       text: "ยังไม่ได้สร้าง Pdf ให้เอกสาร " + doc["documentID"],
    //       type: "error",
    //       show: true,
    //     };
    //   }

    //   let updatedPdfLink = doc["@UpdatedPdfUrl"];

    //   let link = "";

    //   if (!pdfLink && !updatedPdfLink) {
    //     //console.log('take from api')
    //     link = await this.updateThaiSmartTaxPdf(doc["documentID"]);
    //   } else if (pdfLink) {
    //     // console.log("take from field")
    //     link = pdfLink;
    //   } else if (updatedPdfLink) {
    //     link = updatedPdfLink;
    //   }

    //   console.log("linkk:: ", link);

    //   if (!this.pdfDialog && link) {
    //     await axios
    //       .get(link, {
    //         responseType: "arraybuffer",
    //       })
    //       .then(
    //         (response) => {
    //           this.downloadPdfLoading = false;

    //           let url = URL.createObjectURL(
    //             new Blob([response.data], { type: "application/pdf" })
    //           );

    //           if (isMobile()) {
    //             let a = document.createElement("a");
    //             document.body.appendChild(a);
    //             a.style = "display: none";
    //             a.href = url;
    //             a.download = "thaismarttax" + new Date().getTime() + ".pdf";
    //             a.click();
    //             window.URL.revokeObjectURL(url);
    //           } else {
    //             this.pdfSrc = url;
    //             this.pdfDialog = true;
    //           }
    //         },
    //         (error) => {
    //           console.log(error);
    //         }
    //       );
    //   }
    //   this.alert = {
    //     show: false,
    //   };
    //   this.$store.dispatch("setGlobalLoading", false);
    // },
    // updateThaiSmartTaxPdf: async function (docID) {
    //   // get user token
    //   let token = await firebase
    //     .auth()
    //     .currentUser.getIdToken(/* forceRefresh */ false)
    //     .then(function (idToken) {
    //       return idToken;
    //     });
    //   const headers = {
    //     "Content-Type": "application/json",
    //     Authorization: "JWT " + token,
    //   };
    //   let data = {
    //     companyID: this.$route.params.companyId,
    //     docID: docID,
    //   };
    //   const promise = new Promise((resolve, reject) => {
    //     axios
    //       .post(fc.cloudFunctionUrl + "updateThaiSmartTaxPdf", data, {
    //         headers,
    //       })
    //       //.post('http://127.0.0.1:5001/sld-etax/us-central1/' + "updateThaiSmartTaxPdf", data, { headers })
    //       .then(
    //         (response) => {
    //           if (response.status === 200) {
    //             resolve(response.data);
    //           }
    //         },
    //         (error) => {
    //           reject(error);
    //           console.log(error);
    //           this.$store.dispatch("setGlobalLoading", false);
    //           this.downloadPdfLoading = false;
    //         }
    //       );
    //   });
    //   return promise;
    // },
    getDateWithFormat: function (date) {
      let parsedDate;

      if (date && typeof date.seconds === "number" && typeof date.nanoseconds === "number") {
        parsedDate = moment(date.seconds * 1000);
      } else if (moment(date, moment.ISO_8601, true).isValid()) {
        parsedDate = moment(date);
      } else if (moment(date, "MMMM D, YYYY [at] h:mm:ss A [UTC]Z").isValid()) {
        parsedDate = moment(date, "MMMM D, YYYY [at] h:mm:ss A [UTC]Z");
      } else {
        console.error("Invalid date format");
        return "";
      }
      let formattedDate = parsedDate.format("D MMM");

      // Convert the month to Thai abbreviation
      formattedDate = formattedDate.replace("Jan", "ม.ค.");
      formattedDate = formattedDate.replace("Feb", "ก.พ.");
      formattedDate = formattedDate.replace("Mar", "มี.ค.");
      formattedDate = formattedDate.replace("Apr", "เม.ย.");
      formattedDate = formattedDate.replace("May", "พ.ค.");
      formattedDate = formattedDate.replace("Jun", "มิ.ย.");
      formattedDate = formattedDate.replace("Jul", "ก.ค.");
      formattedDate = formattedDate.replace("Aug", "ส.ค.");
      formattedDate = formattedDate.replace("Sep", "ก.ย.");
      formattedDate = formattedDate.replace("Oct", "ต.ค.");
      formattedDate = formattedDate.replace("Nov", "พ.ย.");
      formattedDate = formattedDate.replace("Dec", "ธ.ค.");
      const thaiYear = parseInt(parsedDate.format("YYYY")) + 543;
      formattedDate += " " + thaiYear.toString().substring(2, 4);

      return formattedDate;
    },

    formatDate: function (dateTimestamp) {
      if (dateTimestamp && typeof dateTimestamp.seconds === "number") {
        try {
          const date = new Date(dateTimestamp.seconds * 1000);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();

          return `${day}/${month}/${year}`;
        } catch (error) {
          console.error("Error formatting date:", error);
          return "";
        }
      } else {
        return "";
      }
    },

    formatDate2: function (date) {
      if (!date) return ''; // If there is no date value, return null.
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'Asia/Bangkok',
      };
      const thaiYearOffset = 543;

      if (typeof date === 'string') {
        // Convert date from format "25/12/2024" or ISO string
        const isoDate = new Date(date);
        if (!isNaN(isoDate)) {
          return isoDate
            .toLocaleDateString('th-TH', {
              ...options,
              timeZone: 'Asia/Bangkok',
            })
            .replace(
              (isoDate.getFullYear() + thaiYearOffset).toString(),
              (isoDate.getFullYear() + thaiYearOffset).toString()
            );
        }

        const [day, month, year] = date.split('/').map(Number);
        const formattedDate = new Date(year, month - 1, day);
        return formattedDate
          .toLocaleDateString('th-TH', {
            ...options,
            timeZone: 'Asia/Bangkok',
          })
          .replace(
            (year + thaiYearOffset).toString(),
            (year + thaiYearOffset).toString()
          );
      } else if (date instanceof Date) {
        // Date object
        return date
          .toLocaleDateString('th-TH', {
            ...options,
            timeZone: 'Asia/Bangkok',
          })
          .replace(
            (date.getFullYear() + thaiYearOffset).toString(),
            (date.getFullYear() + thaiYearOffset).toString()
          );
      } else if (date.toDate) {
        // Firestore Timestamp
        const firestoreDate = date.toDate();
        return firestoreDate
          .toLocaleDateString('th-TH', {
            ...options,
            timeZone: 'Asia/Bangkok',
          })
          .replace(
            (firestoreDate.getFullYear() + thaiYearOffset).toString(),
            (firestoreDate.getFullYear() + thaiYearOffset).toString()
          );
      }

      return ''; // If not in a supported format
    },

    onChangeValueFilterList(value) {
      this.clearValue();
      this.$store.dispatch("thaismartTax/setValueFilterList", {
        valueFilterList: value,
      });
    },
    onChangeValueDropdownHideColumn(value) {
      this.valueHideList = value;
    },
    onChangeValueSearchOption(value) {
      this.filterData.fromDate = value.fromDate;
      this.filterData.toDate = value.toDate;
      this.filterData.branchID = value.branchID;
      this.filterData.toNo = value.toNo;
      this.filterData.fromNo = value.fromNo;
      this.filterData.taxType = value.taxType;
      this.filterData.nsDocID = value.nsDocID;
      // this.$store.dispatch("thaismartTax/setSearchField", value);
      this.query();
    },
    showColumn(field) {
      return this.valueHideList.includes(field);
    },
    clearValue: function () {
      this.$store.dispatch("thaismartTaxDetail/updatePage", { page: 1 });
    },
    clearSelectList: function () {
      this.$store.dispatch("thaismartTaxDetail/setSelectedList", {
        selectedList: [],
      });
    },
    errorsMessage: function (errors) {
      return getErrorMessage(errors);
    },
    handlePayeeType: function (payeeType) {
      if (payeeType === "P") {
        return "D : Vat Due";
      } else if (payeeType === "S") {
        return "D : Vat Due";
      } else {
        return "";
      }
    },
    handlePayeeAddress(payeeAddress) {
      if (payeeAddress) {
        // return payeeAddress.split(" ")[0] +  payeeAddress.split(" ")[1] +  payeeAddress.split(" ")[2] || ""
        let truncatedAddress =
          payeeAddress.length > 20
            ? payeeAddress.substring(0, 25) + "..."
            : payeeAddress;
        return truncatedAddress;
      }
      return "";
    },
    clearAllSelectList: function () {
      this.selectedAll = false;
      this.$store.dispatch("thaismartTaxDetail/setSelectedList", {
        selectedList: [],
      });
      this.clearSelectList();
    },
    holdDownloadAndSendEmail: function (status) {
      return companyStatus.holdDownloadAndSendEmail(status);
    },
    autocompleteAddEmail: function (k, value) {
      this.emailInput = "";
      if (value && !this.emailList[k].includes(value)) {
        Vue.observable(this.emailList[k].push(value));
      }
    },
    removeEmail: function (k) {
      this.emailList[k] = [...this.emailValues[k]];
      Vue.observable(this.emailList[k]);
    },
    resetDateSearch: function () {
      this.$store.dispatch("thaismartTaxDetail/setFromDate", "");
      this.$store.dispatch("thaismartTaxDetail/setToDate", "");
      this.$store.dispatch("thaismartTaxDetail/updateKeyword", "");
      this.fromDateVal = null;
      this.toDateVal = null;
      this.clearValue();
    },
    handlePreviewDoc(pdfUrl) {
      this.pdfSrc = pdfUrl;
      this.pdfDialog = true;
    },
    handleSearchClick: function () {
      this.query()
    },
    resetSearchData() {
      this.filterData.branchID = "";
      this.filterData.taxCodeTypes = {
        ...this.vatCodes.reduce((acc, cur) => {
          acc[cur.code] = false;
          return acc;
        }, {}),
      };
      this.filterData.submitStatus = "";
      this.filterData.transactionStatus = "";
      this.filterData.payeeName = "";
      this.filterData.ivType = "";
      this.filterData.fromDate = "";
      this.filterData.toDate = "";

      this.fromDateVal = null;
      this.toDateVal = null;
      this.handleSearchClick();
    },
    onChangeSearchFilterOption(key, value) {
      if (value === "fromDateToDate") {
        this.selectedFilter.fromDateToDate = !this.selectedFilter.fromDateToDate;
      } else if (value === "branchID") {
        this.selectedFilter.branchID = !this.selectedFilter.branchID;
      } else if (value === "fromNoToNo") {
        this.selectedFilter.fromNoToNo = !this.selectedFilter.fromNoToNo;
      } else if (value === "taxType") {
        this.selectedFilter.taxType = !this.selectedFilter.taxType;
      } else if (value === "nsDocID") {
        this.selectedFilter.nsDocID = !this.selectedFilter.nsDocID;
      }
    },
    setTaxCondition: (context) => {
      const route = context.$route;
      // console.log('this is rout',route)
      const lastSegment = route?.path.split("-").pop();
      // console.log('this is rout name ', lastSegment)
      switch (lastSegment) {
        case 'taxSales':
          context?.$store.dispatch("thaismartTaxDetail/setTaxCondition", "S");
          context.headerTitle = "ภาษีขาย"
          break;
        case 'taxBuy':
          context?.$store.dispatch("thaismartTaxDetail/setTaxCondition", "P");
          context.headerTitle = "ภาษีซื้อ"
          break;
        case 'taxBuyAverage':
          context?.$store.dispatch("thaismartTaxDetail/setTaxCondition", "avg")
          context.headerTitle = "ภาษีซื้อเฉลี่ย"
          break;
        case 'CancelTax':
          context?.$store.dispatch("thaismartTaxDetail/setTaxCondition", "Cancel")
          context.headerTitle = "ยกเลิกรายการภาษีมูลค่าเพิ่ม"
          break;
        default:
          context?.$store.dispatch("thaismartTaxDetail/setTaxCondition", "");
          break;
      }
    },
    getTaxWHBranch: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store.dispatch("thaismartTaxDetail/fetchTaxWHBranch", { companyId: companyId })
      }
    },
    handleTimePeriodSelectionAndCloseMenu(item) {
      this.selectedPeriod = item.id;
      this.selectedTimePeriod = item
      // this.handleSelection(item);
      this.$refs.selectMenu.blur();
    },
    getTimePeriods: function () {
      let companyId = this.$route.params.companyId;
      let year = new Date().getFullYear();
      if (companyId) {
        this.$store.dispatch("thaismartTaxDetail/fetchTimePeriods", {
          companyId: companyId,
          year: year,
        });
      }
    },
    getColorClass(item) {
      if (item.type === "quarter") {
        return "bg-quarter";
      } else if (item.type === "year") {
        return "";
      }
      return "";
    },
    displayThaiMonthAndYear(monthYear, doc) {
      if (!monthYear || typeof monthYear != "string") {
        return ""
      }
      let month = monthYear.split(" ")[0]
      month = month[0].toUpperCase() + month.slice(1);
      month = month.replace("Jan", "ม.ค.");
      month = month.replace("Feb", "ก.พ.");
      month = month.replace("Mar", "มี.ค.");
      month = month.replace("Apr", "เม.ย.");
      month = month.replace("May", "พ.ค.");
      month = month.replace("Jun", "มิ.ย.");
      month = month.replace("Jul", "ก.ค.");
      month = month.replace("Aug", "ส.ค.");
      month = month.replace("Sep", "ก.ย.");
      month = month.replace("Oct", "ต.ค.");
      month = month.replace("Nov", "พ.ย.");
      month = month.replace("Dec", "ธ.ค.");
      month = month.replace("Dec", "ธ.ค.");
      const year = (Number.parseInt(monthYear.split(" ")[1]) + 543).toString().slice(2)
      return `${month} ${year}`
    },
    showErrorSnackBar(msg) {
      this.snackBarMsg = msg
      this.snackBarError = true
    },
    showSuccessSnackBar(msg) {
      this.snackBarMsg = msg
      this.snackBarSuccess = true
    },
    async handleSubmitDocClick() {
      try {
        await this.$store.dispatch("thaismartTaxDetail/submitSelectedDoc", {
          timePeriod: this.selectedTimePeriod,
          companyId: this.$route.params.companyId
        });
        this.showSuccessSnackBar("submit document")
      } catch (e) {
        this.showErrorSnackBar("unable to submit document")
      } finally {
        this.sumitDocDialog = false
        this.clearAllSelectList()
      }
    },
    async handleCancelDocClick() {
      try {
        await this.$store.dispatch("thaismartTaxDetail/cancelSelectedDoc", {
          companyId: this.$route.params.companyId
        });
        this.showSuccessSnackBar("cancel document")
      } catch (e) {
        this.showErrorSnackBar("unable to cancel document")
      } finally {
        this.cancelDocDialog = false
        this.clearAllSelectList()
      }
    },
    checkDisabledCheckbox(doc) {
      return doc.items.filter(item => item.taxType == 2).length > 0 || doc?.taxType == 2
    },
  },
};
</script>

<style lang="scss" scoped>
#table-firebase {
  .filter-up {
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  th {
    img {
      width: 10px;
      height: 8px;
    }
  }

  .border-right {
    border-right: 1px solid #ffffff;
  }

  //add arrow to tooltip
  //.v-tooltip__content::before {
  //  content: '';
  //  position: absolute;
  //  display: block;
  //  width: 0px;
  //  left: 50%;
  //  bottom: 6px;
  //  border: 5px solid transparent;
  //  border-bottom: 0;
  //  border-top: 8px solid #191919;
  //  transform: translate(-50%, calc(100% + 5px));
  //}

  .v-text-field fieldset,
  .v-text-field .v-input__control,
  .v-text-field .v-input__slot {
    border-radius: 10px !important;
    border-color: #c4c4c4;
    // margin-top: 5px;
    // margin-bottom: 5px;
    //width: 270px;
  }

  .search-box {
    width: 250px;
  }


  .remove-checkbox-padding {
    margin-top: 0;
    padding-top: 0;
    padding-bottom: 2px;

    .v-input--selection-controls__input {
      margin-right: 0;
    }
  }

  .doc-id {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .v-text-field__details {
    display: none !important;
  }

  .icon-sort {
    cursor: pointer;
  }

  .v-card__title .v-messages {
    min-height: 11px;
  }

  .order-by-row {
    cursor: pointer;
  }

  .icon-downloaded {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-right: 4px;
  }

  th,
  td {
    white-space: nowrap;
  }

  .check-box-flex {
    display: flex;
    align-items: center;
  }

  tr {
    &.tr-data {
      cursor: pointer;
    }
  }

  .icon-button {
    height: -webkit-fill-available;
  }
}

.bg-quarter {
  background-color: #b2dfdb;
}

.numberRow {
  min-width: 3rem !important;
}

.iframe {
  overflow: hidden !important;
  height: 100% !important;
  width: 60% !important;
  position: absolute !important;
  left: 20% !important;
  right: 10% !important;
  top: 0 !important;
}

.disabled-btn {
  color: rgba(0, 0, 0, 0.26) !important;
  cursor: default;
}

.v-btn {
  letter-spacing: unset !important;
}

.btn-choose {
  margin-right: 0px;
}

.btn-submit {
  margin-right: 20px;
}

.inputted-green {

  input,
  .v-select__selections {
    color: #6ec39b !important;
  }
}
.hide-scroll-bar {
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
}
.hide-scroll-bar::-webkit-scrollbar { /* WebKit */
  width: 0;
  height: 0;
}
.checkbox-disabled {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.20;
}


.bg-quarter{
  background-color:#B2DFDB ;
}

</style>
